import React from 'react';
import {
  Constants,
  EnvironmentVariableUtilities,
} from '@pwc/pwc-deals-web-common';
import { useTranslation } from 'react-i18next';
import UserEditSettings, { getInitialState } from './UserEditSettings';
import SupportTicketLink from '../../../../../common/components/SupportTicketLink';

const TeamMembersStep = ({
  initialValues,
  onCancel,
  hasError,
  onStepCompleted,
}) => {
  const formValues = getInitialState();
  if (initialValues && initialValues.length) {
    Object.keys(formValues).forEach((role) => {
      formValues[role] = initialValues.filter((v) => v.role === role);
    });
  }

  const fieldConfigs = [
    {
      role: Constants.USER_ROLES.ENGAGEMENT_LEAD,
      title: Constants.USER_ROLES.ENGAGEMENT_LEAD,
      description: `Full access. This is available for Partner and Managing Director level only.`,
      required: true,
    },
    {
      role: Constants.USER_ROLES.ENGAGEMENT_MANAGER,
      title: Constants.USER_ROLES.ENGAGEMENT_MANAGER,
      description: `Full access to ${EnvironmentVariableUtilities.platformName}.`,
      required: true,
    },
    {
      role: Constants.USER_ROLES.APPROVER,
      title: Constants.USER_ROLES.APPROVER,
      description: `Unable to edit users on ${EnvironmentVariableUtilities.platformName}.`,
      allowMany: true,
    },
    {
      role: Constants.USER_ROLES.TEAM_MEMBER,
      title: Constants.USER_ROLES.TEAM_MEMBER,
      description: 'Unable to edit users or approve content.',
      allowMany: true,
    },
    {
      role: Constants.USER_ROLES.PWC_READONLY,
      title: Constants.USER_ROLES.PWC_READONLY_DISPLAY,
      description: `Unable to contribute, share, approve, comment, and edit users on ${EnvironmentVariableUtilities.platformName}.`,
      allowMany: true,
    },
  ];
  const { t } = useTranslation();
  return (
    <UserEditSettings
      initialValues={formValues}
      fieldConfigs={fieldConfigs}
      onSubmit={onStepCompleted}
      onCancel={onCancel}
      submitButtonText="Next"
      hasError={hasError}
      isDirty={initialValues && initialValues.length ? true : undefined}
    >
      <h3>{t('invitePwcTeamMembersToProject')}</h3>
      <p>
        {t('cantFindMessage')} <SupportTicketLink />
        {'. '}
        {t('includeFullNameMessage')}
      </p>
    </UserEditSettings>
  );
};

export default TeamMembersStep;
